import { h as s } from "vue";
const r = {
  props: {
    /**
     * Data to display in a cell
     */
    data: Object,
    /**
     * Column data
     */
    column: Object
  },
  render() {
    const { scopedSlots: e, property: c, numeric: a } = this.column;
    let t;
    return e ? t = e.default(this.data) : t = this.data[c], s(
      "td",
      {
        class: {
          numeric: a
        }
      },
      [
        s(
          "div",
          {
            class: {
              cell: !0
            }
          },
          t
        )
      ]
    );
  }
};
export {
  r as default
};
//# sourceMappingURL=design-system.es325.js.map
